import { Component, OnInit } from '@angular/core';
// import { Router, ActivatedRoute } from '@angular/router';
import { ApiService } from '../../service/api_service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ExpenseEligiblityModel } from '../../model'
// import { ToastrService } from 'ngx-toastr';
import { HttpClient } from '@angular/common/http';
// import { Injectable } from '@angular/core';
import { Router } from "@angular/router"
import * as $ from 'jquery';
import { ColumnGroup } from 'ag-grid-community';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-expenseeligiblity',
    template: require('./expenseeligiblity.component.html'),
    viewProviders: [ApiService]
})
// @Injectable({
//   providedIn: 'root',
// })
export class ExpenseEligiblityReportComponent implements OnInit {
    ExpenseEligiblityData: ExpenseEligiblityModel = new ExpenseEligiblityModel();
    ExpenseEligiblityDetails: any = [];
    busy: Subscription;
    private columnDefs;
    private rowHeight;
    api: any;
    empName: any = [];
    ManagerList: any
    columnApi: any;
    defaultColDefine;
    private gridColumnApi;
    token: any;

    ExpenseEligiblity_Form = new FormGroup({
        employeeCode: new FormControl('', [Validators.required]),
        ManagerID: new FormControl('', [Validators.required]),
        status: new FormControl('', [Validators.required]),

    });

    static parameters = [ApiService, Router, HttpClient]
    constructor(private apiService: ApiService, private router: Router, private http: HttpClient) {
        this.apiService = apiService;
        this.columnDefs = [
            { headerName: 'Sr. No', valueGetter: "node.rowIndex + 1", width: 80 },
            { headerName: 'Employee Code', field: "Client_Code" },
            { headerName: 'Employee Name', field: "Client_Name" },
            { headerName: 'Designation', field: "Designation" },
            { headerName: 'DOJ', field: "DOJ" },
            { headerName: 'Reporting Manager', field: "Manager" },
            { headerName: 'HQ', field: "HQName" },
            {
                headerName: 'Status', field: "Status"
            },
            { headerName: 'Target', field: "Target" },
            { headerName: 'Fare Rate1', field: "FareRate1" },
            { headerName: 'Upto KM', field: "KM1" },
            { headerName: 'Fare Rate2', field: "FareRate2" },
            { headerName: 'Upto KM', field: "KM2" },
            { headerName: 'Last Working Date', field: "Last Working Date" }
        ];
        this.rowHeight = 50;
        this.defaultColDefine = { resizable: true };

    }


    ngOnInit() {
        this.token = JSON.parse(sessionStorage.getItem("currentUser"));
        $('#filter-option').trigger('click');
        this.getEmployee();
        this.getManagerDetails();
        this.ExpenseEligiblityData.employeeCode = "0";
        this.ExpenseEligiblityData.ManagerID = 0;
        this.ExpenseEligiblityData.status = -1;

    }
    getEmployee() {
        var data = {
            Id: this.token.id
        };
        this.apiService.getEmpDetails(data).subscribe((res: any) => {
            this.empName = res.data;
        })
    }

    getManagerDetails() {
        var data = {
            Id: this.token.id
        };
        this.http.post('/api/Report/getManagerListForLogUnLog', data)
            .subscribe(res => {
                this.ManagerList = res;
            });
    }

    onGridReady = (params) => {
        this.api = params.api;
        this.gridColumnApi = params.columnApi;
        this.api.hideOverlay();
    }

    onBtnExport() {
        this.api.exportDataAsExcel({ fileName: 'EXpense_Eligiblity_Report' });
    }

    onFilterTextBoxChanged() {
        this.api.setQuickFilter(document.querySelector<HTMLInputElement>('#filter-text-box')!.value);
        this.api.refreshCells();
    }

    getExpenseEligiibiltyData() {

        this.ExpenseEligiblityData.empId = this.token.id;
        //console.log(this.ExpenseEligiblityData);
        this.busy = this.apiService.getExpenseEligiibiltyData(this.ExpenseEligiblityData).subscribe((res: any) => {
            console.log("response", res)
            this.ExpenseEligiblityDetails = res.data;
        })


    }


}
